import { Field } from "formik";
import React from "react";
import { CpfCnpjField, Textfield } from "../../../ui/form_fields";
import FormAccordion from "./accordion";

const SpecificFields = ({ setFieldValue, dirty }) => (
  <>
    <Field name="specificFilter" hidden />

    <FormAccordion
      title="Busca específica"
      headerId="specific-header"
      dirty={dirty}
      onChange={(isExpanded) => {
        setFieldValue("specificFilter", isExpanded);
      }}
    >
      <div className="pt-10">
        <Field
          name="specific.nomeCredor"
          label="Nome do credor"
          variant="standard"
          component={Textfield}
        />
      </div>

      <div className="pt-10">
        <Field
          name="specific.documento"
          label="Documento do credor"
          component={CpfCnpjField}
        />
      </div>

      <div className="pt-10">
        <Field
          name="specific.nrPrecatorio"
          label="Número do precatório"
          variant="standard"
          component={Textfield}
        />
      </div>

      <div className="pt-10">
        <Field
          name="specific.nrProcesso"
          label="Número do processo"
          variant="standard"
          component={Textfield}
        />
      </div>

      <div className="pt-10">
        <Field
          name="specific.nomeAdvogado"
          label="Nome do advogado"
          variant="standard"
          component={Textfield}
        />
      </div>

      <div className="pt-10">
        <Field
          name="specific.oabAdvogado"
          label="OAB do advogado"
          variant="standard"
          component={Textfield}
        />
      </div>
    </FormAccordion>
  </>
);

export default SpecificFields;
